module.exports = __webpack_public_path__ + "img/bg_note_02.f7552a86.jpg";